import { Directive, ElementRef, HostListener } from '@angular/core';


@Directive({
  selector: '[appFocusNzSwitch]',
  standalone: false
})
export class NzSwitchFocusDirective {
  constructor(private el: ElementRef) {}

  @HostListener('focusin')
  onFocus() {
    // Find the first button within the host element
    const firstButton = this.el.nativeElement.querySelector('button');

    // If a button is found, set focus to it
    if (firstButton) {
      firstButton.focus();
    }
  }
}
